// extracted by mini-css-extract-plugin
export default {"Panel":"Panel-module__Panel___2Gt1v","PanelContent":"Panel-module__PanelContent___1wBwm"};